<template>
	<div>
		<Loader />
		<div class="d21-profile__content d21-profile__settings">
			<ValidationObserver ref="observer" v-slot="{ passes }">
				<form @submit.prevent="passes(() => {})" autocomplete="disabled" onkeydown="return event.key != 'Enter';">
					<h3>{{ T("ticketing_login_data") }}</h3>
					<div class="mdl-grid">
						<div class="mdl-cell mdl-cell--12-col mdl-cell--12-col-m form-group">
							<label>{{ T("email") }}</label>
							<ValidationProvider name="email" rules="required|email" v-slot="{ errors }">
								<input v-model.trim="Profile.Contact.Email" type="text" class="mdl-textfield__input" />
								<span class="error">{{ errors[0] }}</span>
							</ValidationProvider>
						</div>
						<template v-if="isRegisterForm || doResetPassword">
							<div class="mdl-cell mdl-cell--12-col mdl-cell--12-col-m form-group">
								<label>{{ T("password") }}</label>
								<ValidationProvider name="password" rules="required|min:2" v-slot="{ errors }">
									<input v-model.trim="Profile.Credentials.Password" type="password" class="mdl-textfield__input" />
									<span class="error">{{ errors[0] }}</span>
								</ValidationProvider>
							</div>
							<div class="mdl-cell mdl-cell--12-col mdl-cell--12-col-m form-group">
								<label>{{ T("password_repeat") }}</label>
								<ValidationProvider name="password_repeat" rules="required|min:2" v-slot="{ errors }">
									<input v-model.trim="Profile.Credentials.ex.passwordRepeat" type="password" class="mdl-textfield__input" />
									<span class="error">{{ errors[0] }}</span>
								</ValidationProvider>
							</div>
							<div class="mdl-cell mdl-cell--12-col mdl-cell--12-col-m form-group">
								<passwordStrength :password="Profile.Credentials.Password" :password_repeat="Profile.Credentials.ex.passwordRepeat" @isValid="isValid => isPasswordValid = isValid" />
							</div>
						</template>
						<template v-else>
							<a class="changePassword" @click="doChangePassword">{{ T("ticketing_change_password")}}</a>
						</template>
					</div>
					<h3 class="addressData">{{ T("ticketing_address_data") }}</h3>
					<div class="mdl-grid">
						<div class="mdl-cell mdl-cell--12-col mdl-cell--12-col-m form-group">
							<label>{{ T("mobile") }}</label>
							<ValidationProvider name="mobile" v-slot="{ errors }">
								<input v-model.trim="Profile.Contact.Mobile" type="text" class="mdl-textfield__input" />
								<span class="error">{{ errors[0] }}</span>
							</ValidationProvider>
						</div>
						<div class="mdl-cell mdl-cell--6-col mdl-cell-6-col-m form-group">
							<label>{{ T("givenname") }}</label>
							<ValidationProvider name="givenname" rules="required|min:2|alpha_spaces" v-slot="{ errors }">
								<input v-model.trim="Profile.Contact.GivenName" type="text" class="mdl-textfield__input" />
								<span class="error">{{ errors[0] }}</span>
							</ValidationProvider>
						</div>
						<div class="mdl-cell mdl-cell--6-col mdl-cell-6-col-m form-group">
							<label>{{ T("lastname") }}</label>
							<ValidationProvider name="lastname" rules="required|min:2|alpha_spaces" v-slot="{ errors }">
								<input v-model.trim="Profile.Contact.LastName" type="text" class="mdl-textfield__input" />
								<span class="error">{{ errors[0] }}</span>
							</ValidationProvider>
						</div>
						<div class="mdl-cell mdl-cell--12-col mdl-cell-12-col-m form-group">
							<label>{{ T("street") }}</label>
							<ValidationProvider name="street" rules="required|min:2" v-slot="{ errors }">
								<input v-model.trim="Profile.Contact.Street" type="text" class="mdl-textfield__input" />
								<span class="error">{{ errors[0] }}</span>
							</ValidationProvider>
						</div>
						<div class="mdl-cell mdl-cell--4-col mdl-cell-4-col-m form-group">
							<label>{{ T("postalcode") }}</label>
							<ValidationProvider name="postalcode" rules="required|min:2" v-slot="{ errors }">
								<input v-model.trim="Profile.Contact.PostalCode" type="text" class="mdl-textfield__input" />
								<span class="error">{{ errors[0] }}</span>
							</ValidationProvider>
						</div>
						<div class="mdl-cell mdl-cell--8-col mdl-cell-8-col-m form-group">
							<label>{{ T("city") }}</label>
							<ValidationProvider name="city" rules="required|min:2" v-slot="{ errors }">
								<input v-model.trim="Profile.Contact.City" type="text" class="mdl-textfield__input" />
								<span class="error">{{ errors[0] }}</span>
							</ValidationProvider>
						</div>
					</div>
					<h3 class="addressData">{{ T("ticketing_payment_data") }}</h3>
					<template v-if="!isPaymentEditable">
						<div class="mdl-grid d21-profile-item">

							<div class="mdl-cell mdl-cell--12-col mdl-cell--12-col-m form-group">
								<input v-model="sepa.Owner" type="text" class="mdl-textfield__input" data-lpignore="true" :placeholder="T('account_holder')" />
								<span class="error" v-if="isOwnerInvalid">{{ T("PleaseEnter_AccountHolder") }}</span>
								<span class="error" v-if="isOwnerCharactersInvalid">{{ T("No_accented_arabic_characters_allowed") }}</span>
							</div>
							<div class="mdl-cell mdl-cell--12-col mdl-cell--12-col-m form-group">
								<input v-model="sepa.IBAN" type="text" class="mdl-textfield__input" data-lpignore="true" placeholder="IBAN" />
								<span class="error" v-if="isIbanInvalid">{{ T("enter_iban") }}</span>
								<span class="error" v-else-if="!isIbanInvalid && isIbanCountryInvalid">{{ T("payment_direct_debit_countries") }}: {{ allowedCountries }}.</span>
								<span class="error" v-else-if="isIbanInvalid">{{ T("check_iban") }}</span>
							</div>
							<div class="mdl-cell mdl-cell--12-col form-group" v-if="hub.countryFromIban(sepa.IBAN) !== 'Deutschland'">
								<input v-model="sepa.BIC" type="text" class="mdl-textfield__input" data-lpignore="true" placeholder="BIC" />
								<span class="error" v-if="isBicInvalid">{{ T("check_bic") }}</span>
							</div>
							<div class="mdl-cell mdl-cell--12-col mdl-cell--12-col-m form-group">
								<button class="btn btn-black-outline btn-small f-right" @click="cancelPayment">
									<span>{{ T("cancel") }}</span>
								</button>
							</div>
						</div>
					</template>
					<template v-else>
						<div class="mdl-grid d21-profile-item">

							<div class="mdl-cell mdl-cell--12-col form-group">
								<span class="singleLine">{{ T("owner") }}: {{sepa.Owner}}</span>
							</div>
							<div class="mdl-cell mdl-cell--12-col form-group">
								<span class="singleLine">{{ T("iban") }}: {{sepa.IBAN}}</span>
							</div>
							<div class="mdl-cell mdl-cell--12-col form-group" v-if="sepa.BIC">
								<span class="singleLine">{{ T("bic") }}: {{sepa.BIC}}</span>
							</div>
							<div class="mdl-cell mdl-cell--12-col  form-group">
								<button class="btn btn-black-outline btn-small f-right" @click="editPayment">
									<span>{{ T("edit") }}</span>
								</button>
							</div>
						</div>
					</template>
				</form>
			</ValidationObserver>
			<div class="mdl-grid">
				<div class="mdl-cell mdl-cell--12-col mdl-cell--12-col-m form-group success" v-if="isRegistered">
					<i class="material-icons">check_circle</i>
					{{ T("ticketing_register_success", Profile.Contact.Email) }}
					<br />
				</div>
				<div class="mdl-cell mdl-cell--12-col mdl-cell--12-col-m form-group success" v-else-if="isUpdated">
					<i class="material-icons">check_circle</i>
					{{ T("ticketing_profile_update_success") }}
				</div>
				<div class="mdl-cell mdl-cell--12-col mdl-cell--12-col-m form-group warning" v-else-if="isExisting">
					<i class="material-icons">warning</i>
					{{ T("ticketing_profile_exists")}}
					<a href="#" @click="passwordForgotten">{{ T("ticketing_did_you_forget_password")}}</a>
				</div>
				<div class="mdl-cell mdl-cell--12-col mdl-cell--12-col-m buttons" v-if="!hideButtons && !isRegistered">
					<Button class="btn btn-primary" @click="validate(saveChanges)" :is-loading="isChangePending" :text="T('save')" is-primary />
					<button class="btn btn-black-outline" @click="$router.back()">
						<span>{{ T("cancel") }}</span>
					</button>
				</div>
			</div>
		</div>

		<Modal name="profile.validation" :title="T('errors_occured_during_booking')" :actions="validationModalActions">
			<div class="mdl-grid">
				<div class="mdl-cell mdl-cell--12-col">
					<ul>
						<li v-for="error in validation.errors" :key="error" class="error">
							{{ error }}
						</li>
					</ul>
				</div>
			</div>
		</Modal>
	</div>
</template>

<script>
	import _default from "../mixins/default";
	import Loader from "./ui/loader.vue";
	import baseMixin from "../mixins/base";
	import passwordStrength from './ui/password-strength.vue'
	import {
		EventBus
	} from "../scripts/_eventBus.js";
	import 'vueperslides/dist/vueperslides.css'
	import {
		email,
		min,
		alpha_spaces,
	} from "vee-validate/dist/rules";
	import {
		ValidationObserver,
		ValidationProvider,
		extend
	} from "vee-validate";
	import Modal from "./modal.vue";
	import Button from "./ui/button.vue";

	export default {
		mixins: [baseMixin, _default],
		props: {
			hideButtons: {
				type: Boolean,
				default: false
			}
		},
		components: {
			Loader,
			ValidationObserver,
			ValidationProvider,
			passwordStrength,
			Modal,
			Button,
		},
		name: "d21-profile-settings",
		data() {
			return {
				isNextButtonActive: false,
				isValid: true,
				isRegistered: false,
				buttonShownText: "Änderungen speichern",
				buttonHiddenText: "Änderungen speichern",
				isChangePending: false,
				isPasswordValid: false,
				doResetPassword: false,
				isUpdated: false,
				isExisting: false,
				isIbanInvalid: false,
				isPosted: false,
				isPaymentEditable: false,
				sepa: {
					Owner: null,
					IBAN: null,
					BIC: null
				},
				validation: {
					errors: [],
				}
			};
		},
		created() {
			extend("alpha_spaces", alpha_spaces);
			extend("email", email);
			extend("min", min);
			this.initPayment();
		},
		mounted() {
			const self = this;
			EventBus.$on("onProfileRegister", args => {
				self.validate(self.saveChanges);
			});
		},
		computed: {
			allowedCountries() {
				if (!this.Channel.Payment.Sepa.AllowedCountries || this.Channel.Payment.Sepa.AllowedCountries.length === 0 || this.Channel.Payment.Sepa.AllowedCountries.indexOf("Alle") !== -1) {
					return "";
				} else {
					var countries = "";
					this.Channel.Payment.Sepa.AllowedCountries.forEach(c => countries += ", " + c);
					return countries.substring(2);
				}
			},
			isRegisterForm() {
				return !this.Profile.Token || this.$route.params.section === 'register';
			},
			isDone() {
				return this.isRegistered || this.isUpdated;
			},
			isBicInvalid() {
				return this.hub.countryFromIban(this.sepa.IBAN) !== 'Deutschland' && (this.sepa.BIC === null || this.sepa.BIC === "");
			},
			isOwnerInvalid() {
				if (!this.isPosted) return false;
				return this.sepa.Owner !== null && this.sepa.Owner.length > 0 && this.sepa.Owner.length < 5;
			},
			isIbanInvalidandPosted() {
				if (!this.isPosted) return false;
				return this.isIbanInvalid;
			},
			isIbanCountryInvalid() {
				if (this.Channel.Payment.Sepa.AllowedCountries &&
					this.Channel.Payment.Sepa.AllowedCountries.length > 0 &&
					this.Channel.Payment.Sepa.AllowedCountries.indexOf("Alle") === -1) {
					var country = this.hub.countryFromIban(this.sepa.IBAN);
					return this.Channel.Payment.Sepa.AllowedCountries.indexOf(country) === -1;
				} else {
					return false;
				}
			},
			isOwnerCharactersInvalid() {
				var pattern = "[^A-Za-z':?,\\-\\ (+.ÄäßÖöÜü)/]";
				return this.sepa.Owner !== null && this.sepa.Owner.match(pattern);
			},
			validationModalActions() {
				return [{
					text: this.T('close'),
					onClick: () => {
						this.$modals.hide('profile.validation')
					},
					isPrimary: true
				}];
			},
		},
		methods: {
			initPayment() {
				if (!this.Profile.Payment) {
					this.$set(this.Profile, "Payment", {})
					this.$set(this.Profile.Payment, "Sepa", {})
					this.$set(this.Profile.Payment.Sepa, "IBAN", null)
					this.$set(this.Profile.Payment.Sepa, "Owner", null)
				} else {
					if (this.Profile.Payment.Sepa) {
						if (this.Profile.Payment.Sepa.Owner && this.Profile.Payment.Sepa.IBAN) {
							Object.assign(this.sepa, this.Profile.Payment.Sepa);
							this.isPaymentEditable = true;
						}
					}
				}
			},
			editPayment() {
				this.isPaymentEditable = false;
				Object.assign(this.sepa, {
					Owner: null,
					IBAN: null,
					BIC: null
				});
			},
			cancelPayment() {
				Object.assign(this.sepa, this.Profile.Payment.Sepa);
				this.isPaymentEditable = true;
			},
			toLogin() {
				this.$router.push(`/${this.$route.params.channel}/profile/login`);
			},
			validate(cb) {
				this.isPosted = true;
				this.isIbanInvalid = false;
				// dont check iban if iban is null or already exists in the profile.
				if (this.sepa.IBAN !== null && !this.isPaymentEditable) {
					//assign payment data into profile.
					Object.assign(this.Profile.Payment, {
						Sepa: this.sepa
					});
					// this.Profile.Payment.IsNew = true;
					if (!this.isOwnerInvalid && !this.isOwnerCharactersInvalid && !this.isIbanInvalidandPosted && !this.isIbanCountryInvalid && !this.isBicInvalid) {
						var command = `/validation/${this.Channel.Directory}/iban/${this.sepa.IBAN}`;
						this.apiRequest(command, null, "GET", result => {
							if (result.Meta && result.Meta.IsValid && result.Value) {
								cb();
							} else {
								this.isIbanInvalid = true;
								this.isLoading = false;
							}
						}, err => {
							this.isLoading = false;
							this.validation.errors = [this.T("book_failed_unknown_error")];
							this.$modals.show("profile.validation");
						});

					} else {
						this.isLoading = false;
					}

				} else {
					cb();
				}
			},
			saveChanges() {
				const isRegistration = !this.Profile.Token;
				const fnUpdatePassword = (token) => {
					const passwordParameter = encodeURIComponent(this.Profile.Credentials.Password);
					const tokenParameter = encodeURIComponent(token);
					this.apiRequest(`/profile/${this.$route.params.channel}/approvepasswordreset?token=${tokenParameter}&newPassword=${passwordParameter}`, null, "GET", result => {
						this.isChangePending = false;
						if (result.Meta.IsValid) {
							if (isRegistration) {
								this.isRegistered = true;
							} else {
								this.Profile.Token = token;
								this.isUpdated = true;
							}
						} else {
							this.isRegistered = false;
							this.isUpdated = false;
						}
					}, error => {});
				};

				const profile = this.Profile;
				profile.Payment = !this.isPaymentEditable ? this.Profile.Payment : {};

				//
				this.$refs.observer.validate().then((isValid) => {
					if (isValid) {
						this.isChangePending = true;
						this.apiRequest(`/profile/${this.$route.params.channel}/update`, profile, "PUT", result => {
							if (result.Meta.IsValid) {
								this.isExisting = false;
								if (isRegistration || this.doResetPassword) {
									fnUpdatePassword(result.Value.Token);
								} else {
									this.isUpdated = true;
									//resassign saved Paymetn data into profile
									// this.Profile.Contact = result.Value.Contact;
									this.Profile.Payment = result.Value.Payment
									this.isChangePending = false;
								}
							} else {
								this.isExisting = result.Meta.Message === 'user already exists';
								this.isRegistered = false;
								this.isUpdated = false;
								this.isChangePending = false;
							}
						}, error => {});
					}
				});
			},
			passwordForgotten() {
				this.$emit("onPasswordForgotten", null);
			},
			doChangePassword() {
				this.Profile.Credentials.Password = null;
				this.Profile.Credentials.ex = {
					passwordRepeat: null
				};
				this.doResetPassword = true;
			}
		},
		watch: {
			isChangePending(newStatus, oldStatus) {
				if (newStatus !== oldStatus) EventBus.$emit("loginPendingStatus", newStatus);
			}
		}
	}
</script>